import { http } from '../../config/axios'

export default function patchGerarBoletoFaturamento(id: number): Promise<string> {
  return http
    .patch(`api/faturamento/gerar-boleto/${id}`)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro patchGerarBoletoFaturamento', error)
      throw Error(error.response.data)
    })
}
